<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import axios from 'axios';


let baseURL = process.env.VUE_APP_BASEURL;
if(baseURL == null || baseURL == undefined){
  baseURL = 'http://localtest.me:3000/features'; //redirects to localhost for local testing
}

export var requester = axios.create({
  baseURL: baseURL
});

export default {
  name: 'App'
}

</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  background-color: #fafafa;
}
</style> <!-- margin was edited from 60 -->
